<style scoped lang="scss">
.strengths{
  display: flex;
  margin-top: 30px;
  li{
    flex:1;
    text-align: center;
    border-right: 1px solid #eee;
    padding:0 40px;
    &:last-child{
      border: 0;
    }
    h4{
      font-size: 18px;
      margin-bottom: 10px;
      color:#014492;
    }
  }
}
.cons{
  display: none;
}
.download{
  display: flex;
  flex-wrap: wrap;
  border-left: 1px solid #E4E6EA;
  li{
    width:50%;
    padding:20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #E4E6EA;
    border-right: 1px solid #E4E6EA;
    font-size: 16px;
    cursor: pointer;
    &:nth-of-type(1){
      border-top: 1px solid #E4E6EA;
    }
    &:nth-of-type(2){
      border-top: 1px solid #E4E6EA;
    }
    &:hover{
      color:#014492;
    }
  }
  .btn-primary{
    font-size: 14px;
    span{
      margin-right: 7px;
    }
  }
  .mr41{
    display: block;
  }
  .mr42{
    display: none;
  }
}
.table{
  tr{
    td:first-child{
      background: #F6FAFD;
    }
  }
}
.c-title small{
  margin-top: 10px;
}
.required{
  margin-top: 50px;
  background: none!important;
  margin-left: 0!important;
  font-size: 16px;
}
.desc{
  font-size: 16px;
}
.effect-lists{
  //display: block!important;
  justify-content: space-between;
  flex-wrap:wrap;
  overflow: auto;
}
//.effect-lists1{
//  //display: block!important;
//  justify-content: center;
//  flex-wrap:wrap;
//  overflow: auto;
//}
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (min-width: 300px) and (max-width:400px)
{
  .effect-lists{
    justify-content: flex-start!important;
  }
}
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <div class="wrap wrap-tec">
    <div class="banner con">
      <img src="@/assets/img/产品及服务/基因调控/基因检测panel定制及SNP分型/banner.png" class="img-fluid">
      <div class="info"></div>
    </div>
    <!---移动端-->
    <div class="banner cons">
      <img src="@/assets/img/二级标题Banner/基因检测pannal.jpg" class="img-fluid">
      <div class="info"></div>
    </div>
    <section>
      <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;">
        <bread></bread>
      </div>
      <div class="container" style="margin-bottom: 30px;">
        <p class="desc">大多数遗传病和复杂疾病都和基因突变有很大的联系，SNP 突变是目前临床研究的肿瘤标志物和用药分型的一大热门，围绕科研和临床疾病检测的中高通量的 SNP 检测需求和擎科自有的合成产业链优势，打造了多重 PCR 捕获技术，液相芯片捕获技术，捕获探针合成及相关已完成的疾病检测 pannel。</p>
      </div>
      <div class="container">
        <div class="c-title">服务类型<small>Service type</small></div>
        <table class="table">
          <tr>
            <td style="width: 300px;">芯片名称</td>
            <td>芯片特点</td>
            <td>适用范围</td>
            <td>备注</td>
          </tr>
          <tr>
            <td style="width: 300px;">基于扩增子捕获的靶向基因测序</td>
            <td style="text-align: justify;padding: 10px;">本产品基于多重PCR扩增进行富集建库，测序。</td>
            <td style="text-align: justify;padding: 10px;">对30-1000个SNP进行同时检测对1-30个基因的外显子区域进行检测物种不限</td>
            <td style="text-align: justify;padding: 10px;">灵活实现不同基因位点组合可同时检测50-1000位点极高的在靶率约90%,操作简单</td>
          </tr>
          <tr>
            <td style="width: 300px;">个性化的肿瘤基因panel定制化服务</td>
            <td style="text-align: justify;padding: 10px;">本产品基于探针杂交捕获的靶向基因测序技术平台，我们建立了完善的探针设计、检测流程和分析流程。灵敏度高：ctDNA 起始量可以低至 5 ng，可检测 0.1 % 以上的突变丰度。覆盖度好：100 % 地覆盖目标区域。</td>
            <td style="text-align: justify;padding: 10px;">20-500 个基因全编码区；1000-10000个DNA片段（200 bp-300 bp）。基因融合和拷贝数变异（CNV）：可以检测基因融合和拷贝数变异。</td>
            <td style="text-align: justify;padding: 10px;">捕获效率高：能达到50%-70%在靶率，富集几万倍。灵活性：探针逐个合成，可以灵活地增加所需要的基因。 捕获均匀性：各个探针浓度可以调节，增捕获的均匀性。稳定性高：生物素修饰的DNA探针，稳定，便于标准化，产业化。</td>
          </tr>
          <tr>
            <td style="width: 300px;">肿瘤基因ctDNA二代测序</td>
            <td style="text-align: justify;padding: 10px;">采用探针杂交捕获的靶向基因测序技术与高通量测序技术（NGS）进行样本检测，基于DNA水平，对样本基因编码区域突变检测。</td>
            <td style="text-align: justify;padding: 10px;">应样品更多，杂交捕获也更适合高度降解的福尔马林固定、石蜡包埋（FFPE）DNA 以及肿瘤血液游离NA的检测，因为基于序列互补的杂交捕获仅需要捕获探针与靶区域的部分重叠。</td>
            <td style="text-align: justify;padding: 10px;">
              1、探针逐个合成，可以灵活地增加所需要的基因</br>
              2、覆盖更广。富集技术能够提供均匀性更好的测序序列覆盖率。</br>
              3、利用单分子标签（UMI) 对残留噪音进行矫正或纠错。
            </td>
          </tr>
          <tr>
            <td style="width: 300px;">肺癌36基因检测panel</td>
            <td style="text-align: justify;padding: 10px;">肺癌基因检测试剂盒覆盖了36个与肿瘤用药、预后密切相关基因的基因；检测的变异类型不但包括碱基突变、小片段插入缺失， 还覆盖了临床意义明确的热点融合基因的内含子区域来检测基因融合，并可以准确评估所有基因的拷贝数变化（CNV）。</td>
            <td style="text-align: justify;padding: 10px;">该检测适合FFPE样本和血液游离肿瘤 DNA（ctDNA）检测。查找肺癌患者的驱动突变 寻找合适的靶向药物监测耐药性和复发</td>
            <td style="text-align: justify;padding: 10px;">基因列表：详询</td>
          </tr>
          <tr>
            <td style="width: 300px;">前列腺癌120基因检测panel</td>
            <td style="text-align: justify;padding: 10px;">根据《中国前列腺癌患者基因检测专家共识》、NCCN 指南等的建议以及相关研究进展，本产品全面覆盖了120个与前列腺 癌用药、预后密切相关基因的基因；覆盖了热点融合基因的内含子区域来检测基因融合；并可以准确评估所有基因的拷贝数变化 (copy number variation, CNV。</td>
            <td style="text-align: justify;padding: 10px;">该检测适合前列腺癌FFPE样本和血液游离肿瘤 DNA（ctDNA）检测</td>
            <td style="text-align: justify;padding: 10px;">基因列表：详询</td>
          </tr>
          <tr>
            <td style="width: 300px;">淋巴瘤187基因检测panel</td>
            <td style="text-align: justify;padding: 10px;">根据NCCN指南等的建议以及相关研究进展，本产品覆盖了弥漫大B淋巴瘤（DLBCL）187个与肿瘤用药、预后密切相关基因的基因。</td>
            <td style="text-align: justify;padding: 10px;">该检测适合肿瘤组织样本和血液游离肿瘤DNActDNA）检测。</td>
            <td style="text-align: justify;padding: 10px;">基因列表：详询</td>
          </tr>
        </table>
        <div class="con">
          <!-- <img src="@/assets/img/产品及服务/基因调控/基因检测panel定制及SNP分型/lx.png" class="img-fluid" style="margin-top: 50px;"> -->
        </div>
        <div class="cons">
          <!-- <img src="@/assets/img/产品及服务/基因调控/基因检测panel定制及SNP分型/lx.png" class="img-fluid" style="margin-top: 50px;"> -->
        </div>

      </div>
      <div class="c-title">资源中心<small>Resource center</small></div>
      <div class="container mt30 mb30">
        <ul class="download">
          <li v-for="item in resourcesLists" :key="item.id">
            {{item.name}}
            <el-button type="primary" class="mr41" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
            <el-button type="primary" class="mr41" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>

            <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
            <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>
          </li>
        </ul>
      </div>
      <div class="container">
        <div class="c-title">相关服务<small>Related services</small></div>
        <div class="container con">
          <ul class="effect-lists">
            <li v-for="(item, index) in types" :key="index" class="pointer" :class="{active: currentType === index}" @mouseover="currentType = index" @mouseout="currentType = -1" @click="$router.push(item.ref)">
              <img :src="`/static/img/tk_${item.img}${currentType===index ? '' : ''}.png`">
              <p style="margin-top: 10px;">{{item.name}}</p>
            </li>
          </ul>
        </div>
        <div class="cons" style="margin-top: 20px;">
          <ul class="effect-lists">
            <li v-for="(item, index) in types" :key="index" class="pointer"  @click="$router.push(item.ref)">
              <img :src="`/static/img/tk_${item.img}${currentType===index ? '' : ''}.png`" style="width: 60px;">
              <p style="margin-top: 10px;font-size: 12px">{{item.name}}</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="container">
        <qk-consult type="Virus"/>
      </div>
    </section>
  </div>
</template>
<script>
import { resourceColumns, resourceDownloads } from '@/services/api.index'
import bread from "@/components/bread"
export default {
  components:{
    bread
  },
  data () {
    return {
      currentType: -1,
      currentService: -1,
      types: [
        {name: '基因编辑', img: '1', ref: '/products/Gene_editing'},
        {name: '基因干扰', img: '2', ref: '/products/Gene_interference'},
        {name: '蛋白表达', img: '3', ref: '/products/Protein_expression'},
        {name: '甲基化检测', img: '4', ref: '/products/Methylation_detection'},
        {name: '基因过表达', img: '5', ref: ''},
      ],
      types1: [
        {name: '原核蛋白表达', img: '1', ref: ''},
        {name: '哺乳动物细胞蛋白表达', img: '2', ref: ''},
        {name: '酵母蛋白表达', img: '3', ref: ''},
      ],
      page: 0,
      total: 0,
      resourcesLists: [],
      categoryId: ''
    }
  },
  created () {
    this.getResourceColumns()
  },
  methods: {
    // 资源栏目
    getResourceColumns () {
      resourceColumns().then(res => {
        this.menuLists = res.data
        this.total = this.baseMethods.getTotal(res)
        this.getResourcesLists(res.data[0].id)
      })
    },
    // 根据栏目id获取资源列表
    getResourcesLists (id) {
      this.categoryId = id
      resourceDownloads(1, this.page, 20).then(res => {
        this.resourcesLists = res.data
        this.total = this.baseMethods.getTotal(res)
      })
    },
    // 下载
    bindDownLoad (imgsrc, name) {
      this.baseMethods.downloadImage(imgsrc, name)
    },
    downFile (item) {
      this.baseMethods.courseDownload(item.resourceFile.visitedUrl, item.name)
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getResourcesLists(this.categoryId)
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/views/products/Gene_SNP.vue